import logger from '../../helpers/logger/console'
import { ERROR_LOGOUT_CHECK } from "../actions/ActionConstant";

import { select, takeLatest, all } from "redux-saga/effects";;

const erroCode = [1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007];

function* logoutStatusCheck() {
  try {
    const inputData = yield select((state) => state.errorDetails.error);
    if (erroCode.indexOf(inputData.error_code) !== -1) {
      localStorage.clear();
      window.location.assign("/login");
    } else {
      logger.error("Check Error: false");
    }
  } catch (error) {
    logger.error("Check Error: ", error);
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(ERROR_LOGOUT_CHECK, logoutStatusCheck)]);
}
